


















// Vue
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { mapGetters } from 'vuex';

// Constants
import RouteNames from '@/constants/route-names.ts';

// Views
import PurchaseForm from '@/clickbuy/purchase/views/purchase-form/purchase-form.view.vue';
import FillingInForm from '@/clickbuy/purchase/views/filling-in-form/index.vue';
import CompanionForm from '@/clickbuy/purchase/views/companion-form/index.vue';

@Component({
    components: {
        PurchaseForm,
        FillingInForm,
        CompanionForm,
    },
    computed: {
        ...mapGetters({
            getParticipant: 'getParticipant',
        }),
    },
})
export default class PurchaseView extends Vue {
    @Prop() private convocationId!: string;
    @Prop() private companionId!: string;
    @Prop() private participantId!: string;
    @Prop() private purchaseId!: string;


    private getParticipant!: any;


    get participant() {
        return this.getParticipant(this.participantId);
    }

    get showPurchaseForm() {
        return this.$route.name === RouteNames.cbPurchaseParticipant;
    }

    get showFillingInForm() {
        return this.$route.name === RouteNames.cbPurchase;
    }

    get showCompanionForm() {
        return this.$route.name === RouteNames.cbPurchaseCompanion;
    }
}

